import React from "react";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ClientDetails from "../Modals/ClientDetails";
import UserClientCard from "./UserClientCard";
import dayjs from "dayjs";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#48ac6c",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export interface ClientRow {
  email?: React.ReactNode;
  first_name?: string;
  hasAssessments?: boolean;
  hasPending?: boolean;
  last_name?: string;
  lms_accessed?: boolean;
  start_date?: string;
  [key: string]: React.ReactNode | boolean | undefined;
}

interface UserClientsProps {
  clients: ClientRow[];
}

export default function CustomizedTables(props: UserClientsProps): React.ReactElement {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const [client, setClient] = React.useState<ClientRow>({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const rows = props.clients.reverse();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return isMobile ? (
    <div>
      {rows
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row) => (
          <UserClientCard
            key={row.email as React.Key}
            client={row}
            onView={() => {
              setClient(row);
              setOpen(true);
            }}
          />
        ))}
      <TablePagination
        rowsPerPageOptions={[5, 7, 14, 50]}
        style={{ marginTop: 16, background: "#fafafa", borderRadius: 4 }}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <ClientDetails client={client} open={open} setOpen={setOpen} />
    </div>
  ) : (
    <div>
      <Paper className={(classes as { root?: string }).root} variant='outlined'>
        <TableContainer style={{ maxHeight: 440 }}>
          <Table className={classes.table} aria-label='customized table'>
            <TableHead>
              <TableRow>
                <StyledTableCell align='left' style={{}}>
                  Name
                </StyledTableCell>
                <StyledTableCell style={{}}>Email</StyledTableCell>
                <StyledTableCell align='center' style={{}}>
                  Created
                </StyledTableCell>
                <StyledTableCell align='center' style={{}}>
                  Assignment Status
                </StyledTableCell>

                <StyledTableCell align='center' style={{}}>
                  Assignments
                </StyledTableCell>
                <StyledTableCell align='center'>LMS Accessed</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <StyledTableRow key={row.email as React.Key}>
                    <StyledTableCell
                      component='th'
                      scope='row'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {row.first_name + " " + row.last_name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {row.email}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {dayjs(row.start_date).format("DD/MM/YYYY")}
                    </StyledTableCell>
                    <StyledTableCell
                      align='center'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {!row.hasAssessments ? (
                        <span
                          style={{
                            padding: 3,
                            paddingLeft: 15,
                            paddingRight: 15,
                            borderRadius: 20,
                            fontWeight: "bold",
                            color: "#b94946",
                          }}
                        >
                          None Assigned
                        </span>
                      ) : row.hasPending ? (
                        <span
                          style={{
                            background: "#fcb316",
                            padding: 3,
                            paddingLeft: 15,
                            paddingRight: 15,
                            borderRadius: 20,
                            color: "#fff",
                          }}
                        >
                          Pending
                        </span>
                      ) : (
                        <span
                          style={{
                            background: "#03aab1",
                            padding: 3,
                            paddingLeft: 15,
                            paddingRight: 15,
                            borderRadius: 20,
                            color: "#fff",
                          }}
                        >
                          All Completed
                        </span>
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align='center'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {" "}
                      <Button
                        variant='outlined'
                        size='small'
                        disabled={row.hasAssessments ? false : true}
                        onClick={() => {
                          setClient(row);
                          setOpen(true);
                        }}
                      >
                        View
                      </Button>
                    </StyledTableCell>

                    <StyledTableCell
                      align='center'
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {!row.lms_accessed ? (
                        <CancelIcon style={{ color: " #c73c3c" }} />
                      ) : (
                        <CheckCircleIcon style={{ color: "  #49a87b" }} />
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
          <ClientDetails client={client} open={open} setOpen={setOpen} />
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 7, 14, 50]}
          style={{ borderTop: "1px solid #e3e3e3", background: "#fafafa" }}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />{" "}
      </Paper>
    </div>
  );
}
